<template>
  <div class="ml-6 d-flex" v-if="revealSolution" style="width: 80px">
    <v-simple-checkbox readonly :value="answer.is_correct === 1"></v-simple-checkbox>
    <v-icon class="ml-4 mr-4" color="success" v-if="isCorrectAnswer">mdi-check</v-icon>
    <v-icon class="ml-4 mr-4" color="red" v-else>mdi-cancel</v-icon>
  </div>
</template>

<script>
export default {
  name: 'ElAnswerSolution',
  props: {
    answer: Object,
    revealSolution: Boolean,
    isCorrectAnswer: Boolean
  }
};
</script>
